import { Toolbar, ToolbarButton, ToolbarDivider } from '@fluentui/react-components';
import { SettingsRegular } from '@fluentui/react-icons';
import { NotificationType, useFabricContext } from '@idmc-ms-fabric/integration';
import React, { useCallback } from 'react';

import { useIDQAPageContext } from '../../../context/business/IDQAPage/IDQAPageContext';
import RunProfilingButton from '../../../routes/idqa-details/components/RunProfilingButton';
import { openSettingSidePanel } from '../../../utils/trident-utils';
import useStyles from './RibbonStyle';

export const Ribbon: React.FC = () => {
	const style = useStyles();
	const { extensionClient } = useFabricContext();
	const {
		state: { artifactDetails },
	} = useIDQAPageContext();
	const openSettings = useCallback(async () => {
		if (!artifactDetails) {
			extensionClient.notification.open({
				notificationType: NotificationType.Error,
				message: 'Unable to open settings. Please try again later.',
				title: 'Settings',
			});
			return;
		}
		const { displayName, objectId, folderObjectId } = artifactDetails;
		await openSettingSidePanel({
			extensionClient,
			item: { displayName, objectId, folderObjectId },
			tab: 'About',
		});
	}, [artifactDetails, extensionClient]);
	return (
		<div className={style.container}>
			<Toolbar>
				<RunProfilingButton type="toolbar" />
				<ToolbarDivider />
				<ToolbarButton icon={<SettingsRegular />} onClick={openSettings} />
			</Toolbar>
		</div>
	);
};
